// Hint-knop (snippets/rf-share-hint.liquid): deelt de pagina via het deelmenu
// van het toestel, of valt terug op WhatsApp als dat menu er niet is.
if (!customElements.get('rf-share-hint')) {
  customElements.define(
    'rf-share-hint',
    class RfShareHint extends HTMLElement {
      connectedCallback() {
        this.querySelector('button')?.addEventListener('click', () => this.share());
      }

      async share() {
        const text = this.dataset.text || '';
        const url = this.dataset.url || window.location.href;

        if (navigator.share) {
          try {
            await navigator.share({ text, url });
            return;
          } catch (error) {
            // Zelf geannuleerd: niets doen. Anders door naar WhatsApp.
            if (error.name === 'AbortError') return;
          }
        }

        const message = text ? `${text} ${url}` : url;
        window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank', 'noopener');
      }
    }
  );
}
